<ion-header>
  <ion-toolbar color="primary">
    <ion-title i18n>
      {{ newsIndispo.categorieEnum === NewsIndispoCategorie.news ? 'News' : 'Indisponibilité' }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="content-header">
    <ion-icon [name]="newsIndispo.categorieEnum === NewsIndispoCategorie.news ? 'crt-news' : 'crt-indispo'"></ion-icon>
    <span>{{ newsIndispo.titre }}</span>
  </div>
  <div class="content" [innerHTML]="newsIndispo.contenu" #content></div>
  <div class="auteur">{{ newsIndispo.auteur }}</div>
</ion-content>

<ion-footer no-border>
  <ion-button expand="full" color="danger" (click)="dismissModal()">
    <span i18n>Retour</span>
  </ion-button>
</ion-footer>
